import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuthOrGoHome } from '@router/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuthOrGoHome))
